<div class="very-satured-chip-container">
  <div class="very-satured-chip">
    <span class="very-satured-chip-text ci-paragraph-p1-regular">
      {{ 'Muy saturado' | translate }}
    </span>
  </div>
</div>
